import { memo, useRef } from 'react'
import { useField } from 'formik'

import Error from '../error'
import Base from './base'

const FieldTextarea = ({ name, hideError = false, ...rest }) => {
  const [field, meta] = useField(name)
  const fieldRef = useRef()
  const hasError = !!meta.error && meta.touched && !hideError
  return (
    <>
      <Base ref={fieldRef} hasError={hasError} {...field} {...rest} />
      <Error name={name} />
    </>
  )
}

export default memo(FieldTextarea)
